import dynamic from "next/dynamic";
import GlobeWithTopCtaHomepageFirstFoldConfig from "./globe-with-top-cta-homepage-first-fold-config";
import GlobeWithTopCtaHomepageFirstFoldAdvancedConfig from "./globe-with-top-cta-homepage-first-fold-advanced-config";
const GlobeWithTopCtaHomepageFirstFoldComponent = dynamic(()=>import("./globe-with-top-cta-homepage-first-fold-component"));
export default {
    GlobeWithTopCtaHomepageFirstFoldComponent,
    GlobeWithTopCtaHomepageFirstFoldConfig,
    GlobeWithTopCtaHomepageFirstFoldAdvancedConfig
};
